/*
 * @Author: liuxiaoyan
 * @Date: 2022-10-19 09:42:19
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2022-11-24 15:04:46
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
const ExhitionMoudle = {
    state: {
      level: 0, // 楼层级
      vrStarting: false, // vr模式开启
      artworkId: '', // 默认进入的作品id
      share: '', // 预览/分享/查看
      artList: [], // 作品列表
      selectOne: {}, //选中的作品
      isLoading: false, //是否展示作品
      status: '', //展馆状态
      exhibition: {}, //展馆数据
      musicUrl: '', //音乐播放链接
      orientation: 'portrait',
      userInfo: {},
      tts: {}
  },
    getters: {
      level: state => state.level,
      share: state => state.share,
      status: state => state.status,
      artworkId: state => state.artworkId,
      vrStarting: state => state.vrStarting,
      artList: state => state.artList,
      selectOne: state => state.selectOne,
      isLoading: state => state.isLoading,
      musicUrl: state => state.musicUrl,
      exhibition: state => state.exhibition,
      artLists: state => state.exhibition.itemList||[],
      orientation: state => state.orientation,
      userInfo: state => state.userInfo,
      supportClick: state => state.exhibition.supportClick=='YES',// 支持点赞
      clickSort: state => state.exhibition.clickSort=='YES',// 排行榜
      prizeInfo: state => state.exhibition.prizeInfo || [],
      tts: state => state.tts
    },
    mutations: {
      changeLevel(state, payload) {
        console.log('頁面已經存執');
        state.level = payload;
      },
      CHANGE_LEVEL(state, payload) {
        state.level = payload;
      },
      CHANGE_VRSTARTING(state, payload) {
        state.vrStarting = payload;
      },
      CHANGE_ARTWORKID(state, payload) {
        state.artworkId = payload;
      },
      CHANGE_SHARE(state, payload) {
        console.log('payload',payload);
        state.share = payload;
      },
      CHANGE_STATUS(state, payload) {
        state.status = payload;
      },
      CHANGE_EXHIBITION(state, payload) {
        state.exhibition = payload;
      },
      CHANGE_MUSICURL(state, payload) {
        state.musicUrl = payload;
      },
      CHANGE_ORIENTATION(state, payload) {
        state.orientation = payload
      },
      CHANGE_USERINFO(state, payload) {
        state.userInfo = payload
      },
      CHANGE_ARTLIST(state, payload) {
        state.artList = payload
      },
      CHANGE_SELECTONE(state, payload) {
        state.selectOne = payload
      },
      CHANGE_TTS(state, payload) {
        state.tts = payload
      },
      ALTER_ARTLIST(state, payload) {
        let { id, toggle } = payload;
        let index = _.findIndex(state.artList,(item)=>{
          return item.id === id;
        })
        if (index < 0) return;
        console.log('toggle', id, -1, toggle, state.artList);
        let selOne = state.artList[index].clickCount;
        let clickNum = toggle?selOne+1:selOne-1
        let item = {
          ...state.artList[index],
          clickCount: clickNum >= 0 ? clickNum : 0,
          clickStatus: toggle?'YES':'NO'
        }
        let artList = state.artList;
        artList[index] = item;
        state.artList = artList;
        if (id == state.artworkId) {
          state.selectOne = item;
        }
      },
      ALTER_VOICE(state, payload) {
        let { id, voice } = payload;
        let index = _.findIndex(state.artList,(item)=>{
          return item.id === id;
        })
        let item = {
          ...state.artList[index],
          voice
        }
        let artList = state.artList;
        artList[index] = item;
        state.artList = artList;
        if (id == state.artworkId) {
          state.selectOne = item;
        }
      }
    },
    actions: {
      changeLevelId({ commit }, data) {
        commit('CHANGE_LEVEL', data);
      },
      changeVrStaring({ commit }, data) {
        commit('CHANGE_VRSTARTING', data);
      },
      changeArtWorkId({ commit }, data) {
        commit('CHANGE_ARTWORKID', data);
      },
      changeShare({ commit }, data) {
        commit('CHANGE_SHARE', data);
      },
      changeStatus({ commit }, data) {
        commit('CHANGE_STATUS', data);
      },
      changeExhibition({ commit }, data) {
        commit('CHANGE_EXHIBITION', data);
      },
      changeMusicUrl({ commit }, data) {
        commit('CHANGE_MUSICURL', data);
      },
      changeOrientation({ commit }, data) {
        commit('CHANGE_ORIENTATION', data);
      },
      changeUserInfo({ commit }, data) {
        commit('CHANGE_USERINFO', data);
      },
      changeArtList({ commit }, data) {
        commit('CHANGE_ARTLIST', data);
      },
      changeSelectOne({ commit }, data) {
        commit('CHANGE_SELECTONE', data);
      },
      changeLike({ commit }, data) {
        commit('ALTER_ARTLIST', data);
      },
      changetts({ commit }, data) {
        commit('CHANGE_TTS', data);
      },
      changeVoice({ commit }, data) {
        commit('')
      }
    },
  };
  export default ExhitionMoudle;



// WEBPACK FOOTER //
// ./src/store/modules/Exhibition.js